module.exports = __webpack_public_path__ + "static/img/fangan4.97555dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/fangan4.png
// module id = 9k33
// module chunks = 1